const LOCALE_TO_LANGUAGE = {
  da_dk: 'danish',
  de_at: 'german',
  de_be: 'german',
  de_ch: 'german',
  de_de: 'german',
  en_gb: 'english',
  en_ie: 'irish',
  es_es: 'spanish',
  fi_fi: 'finnish',
  fr_be: 'french',
  fr_ch: 'french',
  fr_fr: 'french',
  ga_ie: 'irish',
  it_ch: 'italian',
  it_it: 'italian',
  nb_no: 'norwegian',
  nl_be: 'flemish',
  nl_nl: 'dutch',
  nn_no: 'norwegian',
  pt_pt: 'portuguese',
  sv_fi: 'swedish',
  sv_se: 'swedish',
};

const KNOWN_LANGUAGES = [
  'danish',
  'dutch',
  'english',
  'finnish',
  'flemish',
  'french',
  'german',
  'irish',
  'italian',
  'norwegian',
  'portuguese',
  'spanish',
  'swedish',
];

const FALLBACK = 'english';

module.exports = function (languageName, override) {
  const tools = require('form/tools')();
  const normalized = String(languageName).replace(/-/g, '_').toLowerCase();
  const resolvedName = LOCALE_TO_LANGUAGE[normalized] || languageName;
  const safeName = KNOWN_LANGUAGES.includes(resolvedName) ? resolvedName : FALLBACK;
  const language = require('translations/' + safeName);
  return tools.merge(language, override);
};
